/**
 * Órdenes en espera (park/hold): guarda carritos a medias para retomarlos.
 * Local (localStorage) y por dispositivo. Fail-soft ante errores de storage.
 */

const KEY = 'pos_holds'

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]')
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list))
  } catch (e) {
    // sin storage: no se pueden guardar ordenes en espera
  }
}

const uuid = () => {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  } catch (e) {
    // fallback
  }
  return 'hold-' + Date.now() + '-' + Math.floor(Math.random() * 1e9)
}

export const holdCount = () => read().length

export const peekHolds = () => read()

export const addHold = (label, snapshot) => {
  const list = read()
  list.push({ id: uuid(), at: Date.now(), label: label || '', snapshot })
  write(list)
}

export const removeHold = (id) => write(read().filter((h) => h.id !== id))
